/**
 * @file まなぶ人ごとの本だなの設定 (教養の区画の分野の並び) のクライアント。
 * @what: `GET /families/{fid}/study/plans/{personId}/shelf_settings` と、同じパスへの PUT (丸ごと上書き)。
 * @why: 分野の並びは人に付く設定で、端末をまたいで同じに見えるべきなので、学習者のデータとして
 *   plan 配下に置く (代表の判断、2026-09-17)。
 * @failure: ApiError を伝播する。subject_order が空 = まだ決めていない、は正常系である。
 */

import { apiFetch } from "@/shared/api/client";

export interface StudyShelfSettings {
  /** 教養の区画の分野 id の並びで、空なら既定の並びである。 */
  subject_order: string[];
  /** 最後に保存した時刻 (サーバの時刻、RFC 3339) で、まだ保存していなければ省略される。 */
  updated_at?: string;
}

function path(familyId: string, personId: string): string {
  return `/families/${encodeURIComponent(familyId)}/study/plans/${encodeURIComponent(
    personId,
  )}/shelf_settings`;
}

export async function fetchShelfSettings(
  familyId: string,
  personId: string,
  signal?: AbortSignal,
): Promise<StudyShelfSettings> {
  return apiFetch<StudyShelfSettings>(path(familyId, personId), signal ? { signal } : {});
}

export async function putShelfSettings(
  familyId: string,
  personId: string,
  subjectOrder: readonly string[],
): Promise<StudyShelfSettings> {
  return apiFetch<StudyShelfSettings>(path(familyId, personId), {
    method: "PUT",
    body: { subject_order: [...subjectOrder] },
  });
}
